
import React from 'react';
import { useRoleAccess } from '@/hooks/useRoleAccess';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import Header from '@/components/shared/Header';
import ContributorWorkflow from '@/components/content/ContributorWorkflow';
import EditorWorkflow from '@/components/content/EditorWorkflow';
import { Edit, Users } from 'lucide-react';

const ContributionWorkflow: React.FC = () => {
  const { canCreateContent, canEditContent } = useRoleAccess();

  if (!canCreateContent) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">Access Restricted</h1>
            <p className="text-black">
              You need contributor access or higher to use the contribution workflow.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Content Contribution & Curation</h1>
          <p className="text-black">
            Collaborative content creation and editorial review workflow
          </p>
        </div>

        <Tabs defaultValue="contribute" className="space-y-6">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="contribute" className="flex items-center gap-2">
              <Users className="h-4 w-4" />
              Contribute
            </TabsTrigger>
            {canEditContent && (
              <TabsTrigger value="review" className="flex items-center gap-2">
                <Edit className="h-4 w-4" />
                Editorial Review
              </TabsTrigger>
            )}
          </TabsList>

          <TabsContent value="contribute">
            <ContributorWorkflow />
          </TabsContent>

          {canEditContent && (
            <TabsContent value="review">
              <EditorWorkflow />
            </TabsContent>
          )}
        </Tabs>
      </div>
    </div>
  );
};

export default ContributionWorkflow;

